
import React, { useEffect, useState, useCallback, useRef, Component, useTransition, lazy, Suspense } from "react";
import CustomTable from "src/components/App/AppGrid/CustomTable/CustomTable";
import { Avatar, Chip, Box, alpha, Typography, DialogContent, DialogTitle, DialogActions, styled } from "@mui/material";
import Welcome from "../components/patient/Welcome";
import theme from "src/config/theme";
import { ReactComponent as Edit2 } from '../../../assets/images/edit-2.svg';
import { ReactComponent as Close } from '../../../assets/images/close-circle.svg';
import { ReactComponent as Add } from '../../../assets/images/add-square.svg';
import { ReactComponent as Clinic } from '../../../assets/images/hospital.svg'
import { useNavigate } from 'react-router-dom';
import NoDataFound from "../components/NoDataFound/NoDataFound";
import { useDispatch, useSelector } from 'react-redux';
import { getClinicRequest, getClinicProfileByIdRequest, postClinicProfileRequest, postUploadLogoRequest } from '../../../modules/app/store/appActions';
import storage from "src/utils/storageUtils";
import RightSidebar from "../../../components/App/RIghtSidebar/RightSidebar";
import DialogBox from "src/components/shared/Dialog/DialogBox";
import ButtonComponent from "src/components/shared/Button";
import AddClinic from "../components/LefSidebarForms/AddClinic/AddClinic";
import ClinicCard from "../components/CustomCard/ClinicCard";
import { textAlign } from "@mui/system";
import { HeaderPart, SaveButton, FooterPart, TabsData, TabsContainer, ProfileContainer, ProfileIcon, ProfileAvatar, BoxContainer } from "../components/LefSidebarForms/style";
import { ReactComponent as AddIcon } from '../../../assets/images/add-square.svg';
import CustomTabs from "src/components/shared/CustomTabs/CustomTabs";
import { ReactComponent as PreviousIcon } from '../../../assets/images/arrow-left 2.svg'
import useResponsive from "src/components/hooks/useResponsive";
import Tooltip from '@mui/material/Tooltip';
import ClinicProfileLandingPage from "src/modules/onBoarding/container/ClinicProfileLandingPage";

// Direct imports for all tabs to avoid lazy loading blank screen and delay on click
import ClinicInfo from "../components/ClinicProfile/ClinicProfileForms/ClinicInfo";
import ClinicTiming from "../components/ClinicProfile/ClinicProfileForms/ClinicTiming";
import PrescriptionTemplate from "../components/ClinicProfile/ClinicProfileForms/PrescriptionTemplate";
import MessageTemplate from "../components/ClinicProfile/ClinicProfileForms/MessageTemplate";
import ClinicLink from "../components/ClinicProfile/ClinicProfileForms/ClinicLink";
import Services from "../components/ClinicProfile/ClinicProfileForms/Services";
import Facilities from "../components/ClinicProfile/ClinicProfileForms/Facilities";
import CustomPatientFields from "../components/ClinicProfile/ClinicProfileForms/CustomPatientFields";
import TaskSetting from "../components/ClinicProfile/ClinicProfileForms/TaskSetting";
import ClinicSetting from "../components/ClinicProfile/ClinicProfileForms/ClinicSetting";
import CmsPageForm from "../components/ClinicProfile/ClinicProfileForms/CmsPageForm";
import ThankYou from "../components/ClinicProfile/ClinicProfileForms/ThankYou";

 export const AvatarIcon = styled(Avatar)({
  width: '64px',
  height: '64px',
  padding: '10px',
  borderRadius: '40px',
  background: 'linear-gradient(0deg, rgba(150, 57, 57, 0.18), rgba(150, 57, 57, 0.18)), #FFFFFF',
  marginBottom: '5px'
})
const columns = [
  { id: "clinicName", label: "Clinic Name", sx: { "& .css-axw7ok": { justifyContent: 'flex-Start !important', width: '400px' }, "& .css-s1474d": { justifyContent: 'flex-start !important' } }, },
  { id: "address", label: "Address", sx: { "& .css-axw7ok": { justifyContent: 'flex-start !important', textAlign: 'left !important' }, textAlign: 'left !important' }, },
];

const tabLabels = [
  { label: 'Clinic Info' },
  { label: 'Clinic Timing' },
  { label: 'Prescription Template' },
  { label: 'Message Template' },
  { label: 'Clinic Link' },
  { label: 'Services' },
  { label: 'Facilities' },
  { label: 'Custom Patient Fields' },
  { label: 'Task Setting' },
  { label: 'Clinic Setting' },
  { label: 'Cms Page' },
  { label: 'Thank You' },
];

const ClinicsContainer = () => {
  const { isMobile, isDesktop, isTablet } = useResponsive();
  const [isPending, startTransition] = useTransition();
  const Width = isMobile || isTablet ? '20px' : '24px';
  const Height = isMobile || isTablet ? '20px' : '24px';
  const [openEdit, setOpenEdit] = useState(false);

  const [isCardView, setIsCardView] = useState(false);
  const [open, setOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false)
  const [clinics, setClinics] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedClinicId, setSelectedClinicId] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);
  const [clinicProfile, setClinicProfile] = useState(null);
  const [loadedProfiles, setLoadedProfiles] = useState({});
  const [clinicProfileData, setClinicProfileData] = useState({});
  const clinicInfoRef = useRef();
  const clinicTimingRef = useRef();
  const prescriptionTempRef = useRef();
  const clinicLinkRef = useRef();
  const clinicSettingRef = useRef();
  const cmsPageRef = useRef();
  const serviceRef = useRef();
  const taskSettingRef = useRef();
  const facilitiesRef = useRef();
  const customPatientFieldsRef = useRef();
  const messageTempRef = useRef();
  const savedClinicSettingDataRef = useRef(null); // Stores clinic setting data synchronously before tab switch

  const handleOpen = (clinicId) => {
    setSelectedClinicId(clinicId);
    setClinicProfileData({});
    if (loadedProfiles[clinicId]) {
      setClinicProfile(loadedProfiles[clinicId]);
    } else {
      setClinicProfile(null);
    }
    setSelectedTab(0);
    savedClinicSettingDataRef.current = null;
    setOpen(true);
    dispatch(getClinicProfileByIdRequest(clinicId, (res) => {
      setClinicProfile(res);
      setLoadedProfiles(prev => ({
        ...prev,
        [clinicId]: res
      }));
    }));
  };

  const handleFinalSubmit = async () => {
    const { _id, createdAt, updatedAt, __v, ...restOfProfile } = clinicProfile || {};

    // Use the saved ref data (captured synchronously before tab switch)
    const clinicSettingToSave = savedClinicSettingDataRef.current
      || clinicProfileData?.clinicSetting
      || clinicProfile?.clinicSetting;

    const updatedProfileData = {
      ...restOfProfile,
      ...clinicProfileData,
      clinicSetting: clinicSettingToSave,
      id: selectedClinicId,
    };

    const cleanObject = (obj) => {
      if (!obj || typeof obj !== 'object') return obj;
      if (Array.isArray(obj)) return obj.map(cleanObject);
      const cleaned = { ...obj };
      delete cleaned.createdAt;
      delete cleaned.updatedAt;
      delete cleaned.__v;
      delete cleaned.status;
      delete cleaned.timezone;
      Object.keys(cleaned).forEach(key => {
        if (cleaned[key] && typeof cleaned[key] === 'object') {
          cleaned[key] = cleanObject(cleaned[key]);
        }
      });
      return cleaned;
    };

    // ONLY send essential fields to avoid "Network Error" (413 Too Large)
    // We prioritize clinicInfo and clinicSetting as those are the most common updates here.
    const optimizedData = {
      id: selectedClinicId,
      clinicInfo: cleanObject(updatedProfileData.clinicInfo),
      clinicSetting: cleanObject(updatedProfileData.clinicSetting),
      taskSetting: cleanObject(updatedProfileData.taskSetting),
    };

    console.log("=== OPTIMIZED PAYLOAD SIZE ===");
    console.log("TOTAL SIZE:", Math.round(JSON.stringify(optimizedData).length / 1024 * 100) / 100, "KB");
    console.log("SENDING:", optimizedData);

    try {
      const response = await new Promise((resolve, reject) => {
        dispatch(postClinicProfileRequest(optimizedData, resolve, reject));
      });

      console.log("7. POST response:", response ? "SUCCESS" : "FAILED");

      if (response) {
        dispatch(getClinicProfileByIdRequest(selectedClinicId, (res) => {
          console.log("8. GET after save - clinicSetting:", JSON.stringify(res?.clinicSetting));
          console.log("9. GET after save - minimumPriorBookingTime:", res?.clinicSetting?.minimumPriorBookingTime);
          setClinicProfile(res);
          setLoadedProfiles(prev => ({
            ...prev,
            [selectedClinicId]: res
          }));
          setClinicProfileData({});
          savedClinicSettingDataRef.current = null;
        }));
      }
    } catch (error) {
      console.error("Error submitting clinic profile:", error);
    }
  };

  const handleOpenEdit = (clinicId) => {
    setSelectedClinicId(clinicId);
    setOpenEdit(true);
  }

  const renderTabContent = () => {
    switch (selectedTab) {
      case 0: return <ClinicInfo data={clinicProfileData?.clinicInfo || clinicProfile?.clinicInfo} innerRef={clinicInfoRef} setClinicProfileData={setClinicProfileData} />;
      case 1: return <ClinicTiming data={clinicProfileData?.clinicTiming || clinicProfile?.clinicTiming} innerRef={clinicTimingRef} setClinicProfileData={setClinicProfileData} />;
      case 2: return <PrescriptionTemplate data={clinicProfileData?.prescriptionTemplate || clinicProfile?.prescriptionTemplate} innerRef={prescriptionTempRef} setClinicProfileData={setClinicProfileData} clinicId={selectedClinicId} />;
      case 3: return <MessageTemplate data={clinicProfileData?.messageTemplate || clinicProfile?.messageTemplate} innerRef={messageTempRef} setClinicProfileData={setClinicProfileData} clinicId={selectedClinicId} />;
      case 4: return <ClinicLink data={clinicProfileData?.clinicLink || clinicProfile?.clinicLink} innerRef={clinicLinkRef} setClinicProfileData={setClinicProfileData} />;
      case 5: return <Services data={clinicProfileData?.services || clinicProfile?.services} innerRef={serviceRef} setClinicProfileData={setClinicProfileData} />;
      case 6: return <Facilities data={clinicProfileData?.facilities || clinicProfile?.facilities} innerRef={facilitiesRef} setClinicProfileData={setClinicProfileData} />;
      case 7: return <CustomPatientFields data={clinicProfileData?.customPatientFields || clinicProfile?.customPatientFields} innerRef={customPatientFieldsRef} setClinicProfileData={setClinicProfileData} clinicId={selectedClinicId} />;
      case 8: return <TaskSetting data={clinicProfileData?.taskSetting || clinicProfile?.taskSetting} innerRef={taskSettingRef} setClinicProfileData={setClinicProfileData} />;
      case 9: return <ClinicSetting data={clinicProfileData?.clinicSetting || clinicProfile?.clinicSetting} innerRef={clinicSettingRef} setClinicProfileData={setClinicProfileData} clinicId={selectedClinicId} />;
      case 10: return <CmsPageForm data={Array.isArray(clinicProfileData?.cmsPage) ? clinicProfileData.cmsPage : Array.isArray(clinicProfile?.cmsPage) ? clinicProfile.cmsPage : []} innerRef={cmsPageRef} setClinicProfileData={setClinicProfileData} />;
      case 11: return <ThankYou />;
      default: return null;
    }
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleNext = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      let currentRef = null;
      switch (selectedTab) {
        case 0: currentRef = clinicInfoRef; break;
        case 1: currentRef = clinicTimingRef; break;
        case 2: currentRef = prescriptionTempRef; break;
        case 3: currentRef = messageTempRef; break;
        case 4: currentRef = clinicLinkRef; break;
        case 5: currentRef = serviceRef; break;
        case 6: currentRef = facilitiesRef; break;
        case 7: currentRef = customPatientFieldsRef; break;
        case 8: currentRef = taskSettingRef; break;
        case 9: currentRef = clinicSettingRef; break;
        case 10: currentRef = cmsPageRef; break;
        default: currentRef = null;
      }

      // BEFORE submitting, if we are on Clinic Setting tab, capture the Formik values
      if (selectedTab === 9 && clinicSettingRef?.current?.values) {
        const vals = clinicSettingRef.current.values;
        const sanitize = (v) => (v === '' || v === undefined || v === null ? 0 : Number(v));
        savedClinicSettingDataRef.current = {
          ...vals,
          acceptingTokens: vals.acceptingTokens ? 'yes' : 'no',
          followUpTaskDays: sanitize(vals.followUpTaskDays),
          establishmentYear: sanitize(vals.establishmentYear),
          consultingFees: sanitize(vals.consultingFees),
          oldCaseConsultingFees: sanitize(vals.oldCaseConsultingFees),
          caseValidityDays: sanitize(vals.caseValidityDays),
          emergencyFees: sanitize(vals.emergencyFees),
          appointmentBookingWindow: sanitize(vals.appointmentBookingWindow),
          minimumPriorBookingTime: sanitize(vals.minimumPriorBookingTime),
        };
      }

      if (currentRef?.current) {
        await currentRef.current.submitForm();
        const { isValid, errors } = currentRef.current;
        if (!isValid || (errors && Object.keys(errors).length > 0)) {
          console.log("Validation failed for tab", selectedTab, errors);
          setIsSubmitting(false);
          return;
        }
      }

      if (selectedTab === tabLabels.length - 2) {
        await handleFinalSubmit();
        startTransition(() => {
          setSelectedTab(tabLabels.length - 1);
        });
      } else if (selectedTab === tabLabels.length - 1) {
        setOpen(false);
      } else {
        startTransition(() => {
          setSelectedTab((prev) => prev + 1);
        });
      }
    } catch (error) {
      console.error("Error in handleNext:", error);
    } finally {
      setIsSubmitting(false);
    }
  };


  const fetchClinics = useCallback(() => {
    const token = storage.get('TOKEN');
    const fetchData = async () => {
      const response = await new Promise((resolve, reject) =>
        dispatch(getClinicRequest(token, resolve, reject))
      );
      if (response && Array.isArray(response.data)) {
        setClinics(response.data);
        response.data.forEach(clinicData => {
          if (clinicData.id) {
            dispatch(getClinicProfileByIdRequest(clinicData.id, (res) => {
              setLoadedProfiles(prev => ({
                ...prev,
                [clinicData.id]: res
              }));
            }));
          }
        });
      }
    };
    fetchData();
  }, [dispatch]);

  useEffect(() => {
    fetchClinics();
  }, [fetchClinics]);

  const tableData = React.useMemo(() => {
    if (open) return [];
    return clinics.map((clinicData) => ({
      clinicId: clinicData.id,
      avatarInitial: clinicData?.clinicName?.charAt(0).toUpperCase() || 'N',
      name: clinicData?.clinicName,
      clinicName: (
        <Box sx={{ display: "flex", justifyContent: 'center', alignItems: "center", gap: "8px" }}>
          <Avatar sx={{ background: theme.palette.primary.light4, color: theme.palette.primary.main }}>{clinicData?.clinicName?.charAt(0).toUpperCase()}</Avatar>
          <span>{clinicData?.clinicName || "N/A"}</span>
        </Box>
      ),
      address: clinicData?.address ? `${clinicData.address}` : "N/A",
    }));
  }, [clinics, open]);

  const fileInputRef = useRef();
  const [logoPreview, setLogoPreview] = useState(null);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file || !selectedClinicId) return;

    const previewUrl = URL.createObjectURL(file);
    setLogoPreview(previewUrl);

    const formData = new FormData();
    formData.append("clinicId", selectedClinicId);
    formData.append("clinicLogo", file);

    for (let pair of formData.entries()) {
      console.log(`${pair[0]}:`, pair[1]);
    }

    try {
      const response = await new Promise((resolve, reject) => {
        dispatch(postUploadLogoRequest(formData, resolve, reject));
      });
      console.log('Logo upload response:', response);

    } catch (error) {
      console.error('Failed to upload logo:', error);
      console.log("on Error:", error.message);
    }
  };

  const baseUrl = process.env.REACT_APP_BASE_API_URL;
  const avatarSrc = logoPreview || (clinicProfile?.clinicInfo?.clinicLogo && `${baseUrl}${clinicProfile.clinicInfo.clinicLogo}`);

  const actions = [

    { label: "Edit", icon: <Edit2 width={Width} height={Height} />, onClick: (row) => handleOpenEdit(row.clinicId) },

    { label: "Clinic Profile", icon: <Clinic width={Width} height={Height} />, onClick: (row) => handleOpen(row.clinicId) },
    // {
    //   label: 'Clinic Landing Page',
    //   icon: <Clinic width={isMobile || isTablet ? '20px' : '24px'} height={isMobile || isTablet ? '20px' : '24px'} />,
    //   onClick: (row) => {
    //     navigate(`/public/cliniclandingpage/${row.clinicId}`);
    //   }
    // }


  ];
  return (
    <>
      <Welcome category="clinics" setIsCardView={setIsCardView} isCardView={isCardView} updateClinics={fetchClinics} />
      <Box sx={{ mb: 16 }} />
      {!open ? (
        <Box sx={{
          height: 'calc(100vh - 240px)',
          margin: 2,
          boxShadow: isMobile || isTablet || isCardView || isCardView ? 'none' : theme.shadows[1],
          borderRadius: '10px',
          border: isMobile || isTablet || isCardView || isCardView ? 'none' : `1px solid ${alpha(theme.palette.gery.black, 0.1)}`,
          backgroundColor: isMobile || isTablet || isCardView ? 'none' : theme.palette.gery.white,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: (isCardView) && Array.isArray(tableData) && tableData.length === 0 ? 'center' : 'space-between',
          alignItems: (isMobile || isTablet || isCardView) && Array.isArray(tableData) && tableData.length === 0 ? 'center' : 'none',
          position: 'relative',
          maxHeight: 'calc(100vh - 240px)'
        }}>

          {(isMobile || isTablet || isCardView) ? (
          tableData.length === 0 ? (
            <NoDataFound
              title="No Clinic Data Found!"
              buttonText="Add Clinic"
              buttonIcon={Add}
              // onClick={handleOpen}
              disabled={true}
            />
          ) : (
            <ClinicCard
              data={tableData}
              handleOpen={handleOpen}
              handleOpenEdit={handleOpenEdit}
            />
          )
        ) : (
          <CustomTable
            columns={columns} data={tableData} actions={actions}
            noDataComponent={
              <NoDataFound
                title="No Clinic Data Found!"
                buttonText="Add Clinic"
                buttonIcon={Add}
                disabled={true}
              // onClick={handleOpen}
              />
            }
          />
        )}

        </Box>
      ) : null}
      <RightSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <DialogBox open={open} onClose={() => setOpen(false)}>
        <HeaderPart>
          Clinic Profile
          <Close width={isMobile || isTablet ? '18px' : '24px'} height={isMobile || isTablet ? '18px' : '24px'} onClick={() => setOpen(false)} style={{ cursor: 'pointer' }} />
        </HeaderPart>
        <DialogContent sx={{ pl: 0, pr: 0, pb: 0 }}>
          <BoxContainer>

            <ProfileContainer>
              <ProfileAvatar src={avatarSrc}>
                {
                  !avatarSrc &&
                  (clinicProfile?.clinicInfo?.clinicName?.[0]?.toUpperCase() || 'D')
                }
              </ProfileAvatar>


              <ProfileIcon onClick={() => fileInputRef.current.click()}>
                <Add width="18px" height="18px" />
              </ProfileIcon>

              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: 'none' }}
              />
            </ProfileContainer>


          </BoxContainer>
          <TabsContainer>
            <CustomTabs
              value={selectedTab}
              tabs={tabLabels}
              onChange={(index) => {
                console.log("Tab change requested to index:", index);
                // Capture data from current tab if it's the Clinic Setting tab before switching
                const clinicSettingTabIndex = 9;
                if (selectedTab === clinicSettingTabIndex && clinicSettingRef?.current?.values) {
                   const vals = clinicSettingRef.current.values;
                   const sanitize = (v) => (v === '' || v === undefined || v === null ? 0 : Number(v));
                   savedClinicSettingDataRef.current = {
                     ...vals,
                     acceptingTokens: vals.acceptingTokens ? 'yes' : 'no',
                     followUpTaskDays: sanitize(vals.followUpTaskDays),
                     establishmentYear: sanitize(vals.establishmentYear),
                     consultingFees: sanitize(vals.consultingFees),
                     oldCaseConsultingFees: sanitize(vals.oldCaseConsultingFees),
                     caseValidityDays: sanitize(vals.caseValidityDays),
                     emergencyFees: sanitize(vals.emergencyFees),
                     appointmentBookingWindow: sanitize(vals.appointmentBookingWindow),
                     minimumPriorBookingTime: sanitize(vals.minimumPriorBookingTime),
                   };
                   console.log(">>> [DEBUG] Tab switched via header. Captured ClinicSetting:", JSON.stringify(savedClinicSettingDataRef.current));
                }
                
                setSelectedTab(index);
              }}
              sx={{
                tabStyles: {
                  color: `${alpha(theme.palette.gery.black, 0.7)}`,
                  selectedColor: theme.palette.primary.main,
                  height: "56px",
                  fontSize: '17px',
                  fontWeight: '400px',
                  lineHeight: '21.62px'
                },
                indicatorStyles: {
                  color: theme.palette.primary.main,
                  height: "2px",
                },
              }}
            />

          </TabsContainer>



          <TabsData sx={
            selectedTab === tabLabels.length - 1
              ? {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'

              }
              : {}
          }>
            {renderTabContent()}
          </TabsData>
        </DialogContent>
        <FooterPart >
          {selectedTab > 0 && (
            <ButtonComponent
              variant="none"
              startIcon={<PreviousIcon width={isMobile || isTablet ? '18px' : '24px'} height={isMobile || isTablet ? '18px' : '24px'} sx={{ color: theme.palette.primary.main }} />}
              onClick={() => setSelectedTab(prev => prev - 1)}
            >
              Previous
            </ButtonComponent>
          )}
          <Tooltip title="Click Next to go to the next tab" arrow>

            <SaveButton
              type="submit"
              variant="outlined"
              startIcon={<AddIcon
                width={isMobile || isTablet ? '18px' : '24px'} height={isMobile || isTablet ? '18px' : '24px'}
                sx={{ color: theme.palette.primary.main }} />}
              onClick={handleNext}
            >
              {selectedTab === tabLabels.length - 2 ? 'Submit' : selectedTab === tabLabels.length - 1 ? 'Done' : 'Next'}
            </SaveButton>
          </Tooltip>
        </FooterPart>
      </DialogBox>

      <DialogBox open={openEdit} onClose={() => setOpenEdit(false)}>
        <AddClinic
          clinicId={selectedClinicId}
          onClose={() => {
            setOpenEdit(false);
            fetchClinics();
          }}
        />
      </DialogBox>

    </>
  )
};


export default ClinicsContainer;
